

import { FC } from 'react';
import { DropdownIndicatorBoxWrapper } from '../styles';
import { ReactComponent as ArrowSvg } from '../assets/arrow.svg';

export const DropdownIndicatorBox: FC<any> = (props) => {
    return (
        <DropdownIndicatorBoxWrapper {...props.innerProps} isActive={props.selectProps.menuIsOpen}>
            <ArrowSvg />
        </DropdownIndicatorBoxWrapper>
    );
};


import { FC } from 'react';
import { DropdownIndicatorBoxWrapper } from '../styles';
import { ReactComponent as ArrowSvg } from '../assets/arrow.svg';

export const DropdownIndicatorBox: FC<any> = (props) => {
    return (
        <DropdownIndicatorBoxWrapper {...props.innerProps} isActive={props.selectProps.menuIsOpen}>
            <ArrowSvg />
        </DropdownIndicatorBoxWrapper>
    );
};
